import { render } from "./ImportActions.vue?vue&type=template&id=769a6ddf&scoped=true"
import script from "./ImportActions.vue?vue&type=script&lang=ts"
export * from "./ImportActions.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-769a6ddf"

export default script